import { ICommit } from "@/apps/merchant3/shared-models/ICommit";
import {
  ActivationMethod,
  RepairStatus,
  RepairType,
} from "@/apps/merchant3/types/DeviceRepair";

const actions = {
  resetRepairStates: ({ commit }: ICommit): void => {
    commit("RESET_REPAIR_STATES");
  },

  setActivationMethod: (
    { commit }: ICommit,
    payload: ActivationMethod
  ): void => {
    commit("SET_ACTIVATION_METHOD", payload);
  },

  setClientName: ({ commit }: ICommit, payload: string): void => {
    commit("SET_CLIENT_NAME", payload);
  },

  setAdditionalContactEmail: ({ commit }: ICommit, payload: string): void => {
    commit("SET_ADDITIONAL_CONTACT_EMAIL", payload);
  },

  setAdditionalContactPhone: ({ commit }: ICommit, payload: string): void => {
    commit("SET_ADDITIONAL_CONTACT_PHONE", payload);
  },

  setDeviceFamilyId: ({ commit }: ICommit, payload: number): void => {
    commit("SET_DEVICE_FAMILY_ID", payload);
  },

  setDeviceModelName: ({ commit }: ICommit, payload: string): void => {
    commit("SET_DEVICE_MODEL_NAME", payload);
  },

  setDeviceTag: ({ commit }: ICommit, payload: string): void => {
    commit("SET_DEVICE_TAG", payload);
  },

  setNewDeviceModelName: ({ commit }: ICommit, payload: string): void => {
    commit("SET_NEW_DEVICE_MODEL_NAME", payload);
  },

  setStatuses: ({ commit }: ICommit, payload: RepairStatus[]): void => {
    commit("SET_STATUSES", payload);
  },

  setPhoneProblemDescription: ({ commit }: ICommit, payload: string): void => {
    commit("SET_PHONE_PROBLEM_DESCRIPTION", payload);
  },

  setRepairType: ({ commit }: ICommit, payload: RepairType): void => {
    commit("SET_REPAIR_TYPE", payload);
  },

  setSamePhysicalDevice: ({ commit }: ICommit, payload: boolean): void => {
    commit("SET_SAME_PHYSICAL_DEVICE", payload);
  },

  setStatus: ({ commit }: ICommit, payload: RepairStatus): void => {
    commit("SET_STATUS", payload);
  },

  setStatusToPrevious: ({ commit }: ICommit): void => {
    commit("SET_STATUS_TO_PREVIOUS");
  },
};

export default actions;
